import component from './ExpandableLayout';

export default component;
